
<sm-title-bar pageTitle="{{ 'support_ticket.title' | translate }}" [backWithParams]="true" [headerCustomTemplate]="addButton">
    <!-- <ng-template #addButton >
      <button mat-flat-button color="accent" (click)="createNewBooking()" *ngIf="selectedValue == '0'">
        Create new booking
        <mat-icon class="material-icons-round" [inline]="true"
          >add_circle</mat-icon
        >
      </button>
      <mat-icon class="material-icons-round" [inline]="true"
      >refresh</mat-icon
    >
      
    </ng-template> -->
  
    <ng-template #addButton>
      <div class="d-flex search-field">
        <div class="support_btntt">
        <button mat-flat-button color="accent" (click)="addNewQuery()">
          <mat-icon class="material-icons-round" [inline]="true">add</mat-icon>
          {{ 'support_ticket.btn_txt' | translate }}
        </button>
      </div>
        <!-- <div style="margin-left: 15px; cursor: pointer;" (click)="refreshScreen()">
          <mat-icon class="material-icons-round" [inline]="true" style="font-size: 2.5rem;
          position: relative;
          top: 7px;
          color: #FFC107;"
          >refresh</mat-icon>
        </div> -->
      </div>
    </ng-template>
  
  </sm-title-bar>

  <div class="cont">
    <!-- <div class="header">
        <h2>Closed queries (4)</h2>
        <button class="new-query-btn">+ Raise New Query</button>
    </div> -->
    <div class="query-list"  *ngIf="supportTicketList.length > 0 && !loader">
      <div class="row">
        <div class="col-sm-3" *ngFor="let item of supportTicketList">
        <div class="query-item closed" (click)="openDetails(item)" >
            <h3>{{item.subject}}</h3>
            <p class="query-description">{{ 'support_ticket.by' | translate }}:   {{item.name}}</p>
            <p class="ticket-id">{{item.creation_time | date: 'MMMM d, y, h:mm a '}}</p>
            <span class="status" [ngStyle]="{'background-color':  item.resolve_status == 1 ? '#0768be' : (item.resolve_status == 0 ? 'green' : (item.resolve_status == 2 ? '#ffaf17' : (item.resolve_status == 3 ? 'red' : '')))}">{{item.resolve_status == 1 ? 'RESOLVED' : (item.resolve_status == 0 ? 'OPEN' : (item.resolve_status == 2 ? 'IN-PROGRESS' : (item.resolve_status == 3 ? 'CLOSED' : '')))}}</span>
        <div class="arrow_btnm">
          <mat-icon>arrow_forward</mat-icon>
        </div>
          </div>
        <!-- <div class="query-item closed">
          <h3>Activations • API Key generation/Website Update</h3>
          <p class="ticket-id">Ticket # 10925959 • Raised 3 months ago</p>
          <p class="query-description">Completed the following steps and added the website details. (Screenshot attached) 1. Account and Setting...</p>
          <span class="status">CLOSED</span>
      </div> -->
    </div>
    </div>
    </div>
</div>

<!-- <ng-container *ngIf="supportTicketList.length == 0 && !loader">
  <div class="merchant_detail_sec"  >
    <div class="mrt_offer" style="padding: 150px;
    text-align: center;">
<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 96 96" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M63.655 21.603a1 1 0 0 0 1.39-.024l3.962-3.964a1.504 1.504 0 1 0-2.129-2.128l-2.618 2.62-.776-.778a1.505 1.505 0 0 0-2.129 2.128zM72.52 19.871h5.95a1.505 1.505 0 0 0 0-3.01h-5.95a1.505 1.505 0 1 0 0 3.01zM61.355 30.256l2.3 2.146a1 1 0 0 0 1.39-.024l3.962-3.964a1.504 1.504 0 1 0-2.129-2.128l-2.618 2.62-.776-.778a1.505 1.505 0 0 0-2.129 2.128zM72.52 30.671h5.95a1.505 1.505 0 0 0 0-3.01h-5.95a1.505 1.505 0 1 0 0 3.01zM68.134 37.235a1.504 1.504 0 0 0-2.128 0l-.777.777-.777-.777a1.504 1.504 0 1 0-2.128 2.128l.777.777-.777.777a1.504 1.504 0 1 0 2.128 2.128l.777-.777.777.777a1.5 1.5 0 0 0 2.128 0 1.504 1.504 0 0 0 0-2.128l-.777-.777.777-.777a1.504 1.504 0 0 0 0-2.128zM72.52 41.62h5.95a1.505 1.505 0 0 0 0-3.01h-5.95a1.505 1.505 0 1 0 0 3.01z" fill="#b0b0b0" opacity="1" data-original="#000000" class=""></path><path d="M82.703 8.374H58.406a5.304 5.304 0 0 0-5.297 5.296v13.26a1.505 1.505 0 0 0 3.01 0V13.67a2.291 2.291 0 0 1 2.288-2.287h24.297a2.291 2.291 0 0 1 2.288 2.287v32.545a2.291 2.291 0 0 1-2.288 2.287H65.425a1.505 1.505 0 1 0 0 3.01h17.278A5.304 5.304 0 0 0 88 46.216V13.67a5.304 5.304 0 0 0-5.297-5.296zM55.98 68.601h-.005L55 68.385c1.018-.858 1.49-2.254 1.103-3.648-.356-1.183-.953-3.407-.953-5.008v-1.473c2.308-.659 4.013-2.765 4.013-5.282v-4.977a5.478 5.478 0 0 0-1.616-3.901 5.46 5.46 0 0 0-2.396-1.38v-.734c0-7.467-6.076-13.543-13.543-13.543h-8.026c-7.468 0-13.543 6.076-13.543 13.543v.734a5.472 5.472 0 0 0-2.398 1.382 5.477 5.477 0 0 0-1.615 3.899v4.977c0 2.518 1.704 4.623 4.013 5.282v1.473c0 1.162-.337 2.945-.954 5.045a3.482 3.482 0 0 0 1.108 3.611l-.979.216h-.005c-.922.208-9.036 2.202-9.971 8.758l-1.223 8.549a1.505 1.505 0 0 0 1.49 1.718h56.179a1.506 1.506 0 0 0 1.489-1.716l-1.222-8.549c-.935-6.558-9.049-8.553-9.971-8.76zm-.834-22.559c.088.068.194.104.274.183.472.472.733 1.101.733 1.771v4.977a2.511 2.511 0 0 1-2.508 2.508h-2.448c1.091-2.436 1.748-5.141 1.984-7.863 1.566-.117 1.95-.892 1.965-1.576zm-5.542 21.11c-.753-.187-3.467-1.113-3.48-1.118-1.133-.451-2.006-1.352-2.473-2.459 2.414-1.118 4.365-2.898 5.862-5.085h2.627v1.238c0 1.887.588 4.236 1.072 5.843a.497.497 0 0 1-.332.613c-.883.27-2.031.611-3.276.968zm.016 3.101-2.807 3.741a4.486 4.486 0 0 1-4.704 1.671l-1.677-.419 5.582-6.009c.267.102 2.514.755 3.606 1.016zm-20.628-4.186c-.527.227-2.664.899-3.423 1.088a133.567 133.567 0 0 1-3.258-.977.484.484 0 0 1-.333-.578c.489-1.66 1.071-4.025 1.071-5.872V58.49h2.756c1.473 2.148 3.388 3.911 5.753 5.033a4.561 4.561 0 0 1-2.566 2.544zm5.76 9.182-1.671.417a4.491 4.491 0 0 1-4.705-1.671l-2.806-3.74c.135-.032 3.325-.911 3.58-1.007zm-9.613-27.81c1.9-.241 4.318-.706 6.596-1.472 2.958-.995 4.775-2.193 5.86-3.399 1.088 1.209 2.913 2.408 5.883 3.401 2.325.778 4.789 1.242 6.704 1.477-.245 2.828-1.026 5.646-2.351 8.035h-5.607a1.505 1.505 0 0 0 0 3.01h3.399c-1.996 2.05-4.636 3.362-7.958 3.362-7.853 0-11.939-7.273-12.526-14.414zm-2.091-5.458c0-5.808 4.725-10.534 10.534-10.534h8.026c5.808 0 10.534 4.726 10.534 10.534v2.637c-2.651-.161-9.062-1.238-11.844-3.605-.784-.668-1.165-1.334-1.165-2.042 0-.843-.712-1.53-1.537-1.505-.818-.014-1.537.662-1.537 1.505 0 .711-.385 1.381-1.177 2.053-2.802 2.375-9.197 3.447-11.833 3.601v-2.644zm-4.012 10.992v-4.977c0-.67.26-1.299.731-1.769.08-.08.187-.117.275-.184.018.703.424 1.502 2.1 1.587.226 2.707.881 5.411 1.975 7.851h-2.574a2.51 2.51 0 0 1-2.507-2.508zM36.09 84.616H11.24l.977-6.832c.661-4.634 7.363-6.182 7.648-6.244l.004-.002 2.488-.549 3.609 4.812a7.51 7.51 0 0 0 6.01 3.012c.608 0 4.113-.796 4.113-.796v6.599zm-4.165-16.805a7.515 7.515 0 0 0 2.464-3.309 14.942 14.942 0 0 0 6.421.023 7.508 7.508 0 0 0 2.432 3.275l-5.65 6.082zm7.174 16.805v-6.6s3.504.796 4.113.796a7.503 7.503 0 0 0 6.009-3.012l3.61-4.812 2.487.549.005.002c.285.063 6.987 1.613 7.648 6.246l.977 6.83H39.099z" fill="#b0b0b0" opacity="1" data-original="#000000" class=""></path></g></svg>
<h3 style="margin-top: 16px;
color: #7c7c7c;
font-size: 20px;
margin-bottom: 5px;">
        {{ 'support_ticket.placeholder1' | translate }}
      </h3>
      <p style="color: #7c7c7c;">
        {{ 'support_ticket.placeholder2' | translate }}
      </p>
    </div>
  </div>   
</ng-container> -->
<mat-paginator
*ngIf="supportTicketList.length > 0 && !loader"
  class="mt-4"
  [length]="datalength"
  [pageSize]="25"
  (page)="onPageChange($event)"
>
</mat-paginator>



 <!-- placeholder html start -->
 <div class="placeholder_started" *ngIf="supportTicketList.length == 0 && !loader">
  <div class="row">
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card>
            <div class="upload_sectio">
           <div class="icm_img">
              <img src="./assets/images/support_titk.png">
           </div>
           <mat-card-title>No support ticket to show
          </mat-card-title>
           <mat-card-content>Your business yet not created any support ticket to get express help from the platform. Once you start creating one, all the tickets will appear here with the latest updates from the support staffs.  

          </mat-card-content>
          <div class="watch_vc_btn">
            <button mat-stroked-button color="primary" (click)="addNewQuery()">
               <mat-icon>add</mat-icon>
               Raise New Query 
            </button>
         </div>
           </div>
        </mat-card>
     </div>
    </div>
    <div class="col-sm-4">
      <div class="dashboard_new">
        <mat-card>
            <div class="upload_sectio">
           <div class="icm_img">
              <img src="./assets/images/helpsupport.png">
           </div>
           <mat-card-title>Facing any issue?</mat-card-title>
           <mat-card-content>For any difficulties in creating a support ticket or if there's any issue while getting the list, contact our support team.
          </mat-card-content>
           <div class="watch_vc_btn">
              <button mat-stroked-button color="primary"  (click)="opencontact()">
                 <mat-icon>support_agent</mat-icon>
                 Contact support 
              </button>
           </div>
           </div>
        </mat-card>
     </div>
    </div>
  </div>
</div> 
<!-- placeholder html end -->
 